<template>
  <div class="app-container">
    <list ref="list">
        
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/production/ticketmanagement/progress/list'

export default {
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {
  }
  
};
</script>